import { FormValidatorFn } from './validators/validators.models';

export function setupFormControl(
    name: string, 
    page: HTMLElement, 
    selector: string, 
    validators: FormValidatorFn[]
) {
    const block = page.querySelector(selector) as HTMLInputElement;
    const input = block.querySelector('input');
    const formControlBlock = block.querySelector('.o-form-control');
    const errorHint = block.querySelector('.o-form-control__hint');

    if (!block || !input || !errorHint || !formControlBlock) {
        throw new Error(`${ name } field not setup properly`);
    }

    input.addEventListener('blur', () => {
        const errors = validators
                        .map(validatorFn => validatorFn(input.value))
                        .filter(value => !!value);
        const errorMessage = errors.length ? errors[0] : '';

        errorMessage ? formControlBlock.classList.add('o-form-control--error') : formControlBlock.classList.remove('o-form-control--error');
        errorHint.textContent = errorMessage;
    });  
}
